import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useGetDealerDetails from './useGetDealerDetails';
import { selectDealerAndVehicleData, setDealer } from '../redux/dealerAndVehicleReducer';
import { selectAppConfig } from '../redux/appConfigReducer';
import { prepareDealerIdToGetInfo } from '../functions/dealerIdConverter';

const useDealerInfo = () => {
  const dispatch = useDispatch();

  const { dealerId, market } = useSelector(selectAppConfig);
  const { vehicle } = useSelector(selectDealerAndVehicleData);

  const finalDealerId = useMemo(() => {
    if (dealerId) return prepareDealerIdToGetInfo(dealerId, market);
    if (vehicle && !dealerId) return prepareDealerIdToGetInfo(vehicle.dealerId!, market);
    return null;
  }, [dealerId, market, vehicle]);

  const { dealerInfo, isLoadingDealer } = useGetDealerDetails(finalDealerId);

  useEffect(() => {
    if (!dealerInfo) return;
    dispatch(setDealer(dealerInfo));
  }, [dealerInfo, dispatch]);

  const { dealer } = useSelector(selectDealerAndVehicleData);

  return { dealer, isLoadingDealer };
};

export default useDealerInfo;
